import * as React from "react"

import { cn } from "@/shared/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    const isFileInput = type === "file"

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background text-base ring-offset-background transition-colors md:text-sm",

          !isFileInput &&
          "px-3 py-2 placeholder:text-[#64748B]",

          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
          "disabled:cursor-not-allowed disabled:opacity-50",

          isFileInput &&
          [
            "cursor-pointer overflow-hidden p-0",
            "file:mr-4",
            "file:h-full",
            "file:border-0",
            "file:bg-muted",
            "file:px-4",
            "file:text-sm",
            "file:font-medium",
            "file:text-foreground",
            "file:cursor-pointer",
            "hover:file:bg-muted",
            "file:transition-colors",
          ],

          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

Input.displayName = "Input"

export { Input }